import ifficient from './ifficient';
import optintelligence from './optintelligence';
import permissiondata from './permissiondata';
import react2 from './react2';
import rexadz from './rexadz';
import twyne from './twyne';
import covalent from './covalent';
import tiburon from './tiburon';
import linkoutquestion from './linkout-question';
import callquestion from './call-question';
import tcpaquestion from './tcpa-question';
import tcpaconfirmation from './tcpa-confirmation';
import tcpaform from './tcpa-form';
import nitro from './nitro';
import accountpassword from './accountpassword';
import fluent from './fluent';
import tcpaquestioncustom from './tcpa-question-custom';

export default {
  tcpaform,
  ifficient,
  optintelligence,
  permissiondata,
  react2,
  twyne,
  rexadz,
  covalent,
  tiburon,
  linkoutquestion,
  callquestion,
  tcpaquestion,
  tcpaconfirmation,
  nitro,
  accountpassword,
  fluent,
  tcpaquestioncustom,
};
